export default __webpack_public_path__ + "static/media/138.8f780ca0.jpg";